import React, { useState, MouseEvent } from 'react';
import classNames from 'classnames';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

import { useAppSelector } from 'src/app/hooks';
import {
  selectCredits,
  selectCreditsOpen,
  selectSoundEnabled,
} from 'src/state';

import { ArrowButton, ArrowDirection } from './ArrowButton';
import qr from './qr_code.svg';
import styles from './CreditsModal.module.css';

interface Props {
  className?: string;
}

export function CreditsModal({ className }: Props) {
  const [showingQr, setShowingQr] = useState(false);
  const credits = useAppSelector(selectCredits);
  const isSoundEnabled = useAppSelector(selectSoundEnabled);
  const creditsAreOpen = useAppSelector(selectCreditsOpen);

  const onClick = (event: MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    setShowingQr(!showingQr);
  }

  const hideArrowKeys = isSoundEnabled && !creditsAreOpen;

  return (
    <div className={classNames(styles['credits-modal'], className)}>
      <div className={styles['credits-left-border']} />
      {showingQr ?
        <>
          <img className={styles['qr']} src={qr} alt="Logo" />
          <a
            className={styles['link']}
            href="https://explore.echoes.xyz/collections/ZTNiaUntcfS9eupp"
            target="_blank"
            rel="noreferrer"
          >
            explore the soundwalk
          </a>
        </> :
        <div className={styles['credits-text']}>
          {documentToReactComponents(credits['en-US'])}
        </div> 
      }
      <div className={styles['credits-right-border']} />
      <ArrowButton
        direction={ArrowDirection.Up}
        onClick={onClick}
        hidden={hideArrowKeys}
      />
      <ArrowButton
        direction={ArrowDirection.Down}
        onClick={onClick}
        hidden={hideArrowKeys}
      />
    </div>
  );
}
